import(/* webpackMode: "eager" */ "/codebuild/output/src3140639688/src/ispai/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["OpenerCommunicatorContextProvider"] */ "/codebuild/output/src3140639688/src/ispai/frontend/src/components/C1Opener/OpenerCommunicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3140639688/src/ispai/frontend/src/components/ConfigureAmplifyClientSide.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3140639688/src/ispai/frontend/src/components/FontLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GigyaContextProvider"] */ "/codebuild/output/src3140639688/src/ispai/frontend/src/components/GigyaContext/GigyaLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppContextProvider"] */ "/codebuild/output/src3140639688/src/ispai/frontend/src/context/AppContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorProvider"] */ "/codebuild/output/src3140639688/src/ispai/frontend/src/context/ErrorContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetupAxiosInterceptor"] */ "/codebuild/output/src3140639688/src/ispai/frontend/src/utils/axios.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3140639688/src/ispai/frontend/src/utils/GlobalErrorHandler.tsx");
